import { render, staticRenderFns } from "./SimpleLayout.vue?vue&type=template&id=4f3706dc&scoped=true&"
import script from "./SimpleLayout.vue?vue&type=script&lang=js&"
export * from "./SimpleLayout.vue?vue&type=script&lang=js&"
import style0 from "../styles/landing.less?vue&type=style&index=0&lang=less&"
import style1 from "./SimpleLayout.vue?vue&type=style&index=1&id=4f3706dc&scoped=true&lang=css&"
import style2 from "./SimpleLayout.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3706dc",
  null
  
)

export default component.exports